import { IframeMessageToParent } from '@app/types';

/** Send a message to a parent that is iframing this app into it. */
export function sendIframeMessageToParent(message: IframeMessageToParent) {
  window.parent.postMessage(message, '*');
}
